import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  size?: 'lg' | 'xl';
  className?: string;
  animatePulse?: boolean;
}
export function CTAButton({
  text,
  size = 'lg',
  className = '',
  animatePulse = false
}: CTAButtonProps) {
  const CART_LINK = 'https://mujeresempoderadas.lat//cart/add?id=52253726802219&quantity=1';
  const sizeClasses = {
    lg: 'py-4 px-8 text-base md:text-lg',
    xl: 'py-5 px-10 text-xl md:text-2xl'
  };
  const handleClick = () => {
    // Fire UTMify ADD_TO_CART event
    try {
      if ((window as any).Utmify) {
        ;
        (window as any).Utmify.track('AddToCart');
      }
    } catch (e) {
      // Silently fail if pixel not loaded
    }
  };
  return <motion.a href={CART_LINK} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-block text-center font-heading font-bold text-white tracking-wider
        bg-[#F7B750] hover:bg-[#F5A623]
        rounded-2xl shadow-[0_10px_30px_-8px_rgba(247,183,80,0.6)] ring-2 ring-white/30
        transition-all duration-300 hover:shadow-[0_12px_24px_-8px_rgba(247,183,80,0.6)]
        w-full sm:w-auto
        ${sizeClasses[size]}
        ${animatePulse ? 'animate-pulse-slow' : ''}
        ${className}
      `} data-id="element-112">
      {text}
    </motion.a>;
}